import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { Helper } from "../../../core/utils/Helper";
import { DataUtil } from "../base/DataUtil";
import { BaseServerData } from "../base/IData";

export abstract class CoreData extends DataUtil {

    protected data: BaseServerData;
    protected updatedEval: string[][] = [];
    protected _windowReel: string[][];

    public get windoReels(): string[][] {
        return this._windowReel;
    }

    constructor(){ super() }

    public apply(data: BaseServerData):void { 
        this.data = data;
        this.updateEval();
        this._windowReel = this.createWindowReel();
    }

    createWindowReel():string[][]{
        const temp:string[][] = ArrayHelper.initArrayWithValues(this.data.reels.length,() => []);

        ArrayHelper.eachForEach(this.data.reels,(reel,row) => {
            if(row && row < 4){
                temp[reel].push(this.data.reels[reel][row]);
            } 
        })

        return temp;
    }


    public isWinBelowStake(): boolean { console.warn("isWinBelowStake : Is not Replaced!"); return false;};
    public isIndiviWinBelowStake(): boolean { console.warn("isWinBelowStake : Is not Replaced!"); return false;};

    updateEval():void{
        if(this.data.evaluatedArea){
            let reelHeight:number = this.data.evaluatedArea[0].length;
            this.updatedEval = [];
            this.data.reels.forEach(value => this.updatedEval.push(value.filter((v,i) => i && i < (reelHeight+1))));
            ArrayHelper.eachForEach(this.updatedEval,(i,k) => {
                if(this.updatedEval[i][k] === "M"){
                    this.updatedEval[i][k] = this.data.mysterySymbolRevealed;
                }
                if(this.data.evaluatedArea[i][k] === "W"){
                    this.updatedEval[i][k] = "W";
                }
                if (this.data.evaluatedArea[i][k] === "XWILD") {
                    this.updatedEval[i][k] = "XWILD";
                }
            });
        }
    }

    protected fetchSymbolPos(symType: string, windowReel: string[][], singleSymPerReel?: boolean): number[][] | number[] {
        const arr: number[][] | [] = [];

        let pos: number = -1;
        for (let reel: number = 0; reel < windowReel.length; reel++) {
            if (!singleSymPerReel) arr[reel] = [];
            else pos = -1;
            for (let row: number = 0; row < windowReel[reel].length; row++) {
                if (windowReel[reel][row] == symType) {
                    if (singleSymPerReel) {
                        pos = row;

                        break;
                    }
                    else arr[reel].push(row)
                }
            }
            if (singleSymPerReel) (arr as number[]).push(pos)
        }
        return arr;
    }
}
